import React from "react";
import { Typography, Card, CardActionArea, CardHeader, CardContent, CardMedia } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {} from "@material-ui/core/colors";

const useStyles = makeStyles({
  card: {
    maxWidth: 500,
    float: "right",
  },
  media: {
    height: 400, // necessory for card image
  },
  cardHeader: {
    backgroundColor: "#3F51B5",
    color: "#FFFFFF",
  },
});

export const TIATreatment = () => {
  const classes = useStyles();
  return (
    <div>
      <Typography variant="h3">TIA (transient ischemic attack) treatment</Typography>

      <Typography variant="body1">
        low-risk TIA, defined by an ABCD2 score &lt; 4. We start aspirin (162 to 325 mg/daily) alone.
      </Typography>
      <Typography variant="body1">
        High risk TIA, ABCD2 score&ge;4, suggest use dual antiplatelet therapy (DAPT) using aspirin (160 to 325 mg
        loading dose, followed by 50 to 100 mg daily) plus clopidogrel (300 to 600 mg loading dose, followed by 75 mg
        daily) for the first 21 days.
      </Typography>
      <Typography variant="body1">
        If patient is on aspirin or clopidogrel at the time of TIA onset, we suggest asa plus clopidogrel for the first
        21 days for high-risk TIA (an ABCD2 score of &ge;4).
      </Typography>
    </div>
  );
};
